<div class="submission-status">
  <div class="submission-status-title" [ngClass]="outcomeStyle.tone">
    <i class="submission-status-icon" [ngClass]="outcomeStyle.icon" aria-hidden="true"></i>
    {{ "SubmissionStatus.Title" | translate }}
    @if (submissionStatus.outcomeKey) {
    -
    <span class="submission-status-outcome">{{
      submissionStatus.outcomeKey | translate
      }}</span>
    }
  </div>
  <div class="submission-status-meta">
    <span class="submission-status-claim-id"><strong>{{ "SubmissionStatus.ClaimId" | translate }}</strong>: {{
      submissionStatus.claimId }}</span>
    @if (submissionStatus.submitted) {
    |
    <span class="submission-status-submitted"><strong>{{ "SubmissionStatus.Submitted" | translate }}</strong>: {{
      submissionStatus.submitted | date: dateFormat }}</span>
    }
    @if (checking) {
    |
    <span class="submission-status-checking"><strong>{{
        "SubmissionStatus.CheckingNow" | translate
        }}</strong></span>
    } @else if (submissionStatus.lastChecked) {
    |
    <span class="submission-status-last-checked"><strong>{{ "SubmissionStatus.LastChecked" | translate }}</strong>: {{
      submissionStatus.lastChecked | date: dateFormat }}</span>
    }
  </div>
  @for (error of submissionStatus.errors; track $index) {
  <div class="submission-status-error">{{ error }}</div>
  }
  <div class="submission-status-items">
    @for (item of submissionStatus.items; track $index) {
    <div class="submission-status-item">
      <span class="submission-status-item-label">{{
        "SubmissionStatus.Item" | translate: { sequence: item.sequence }
        }}</span>
      @if (checking) {
      <img class="submission-status-spinner" src="./assets/spinner.png" alt="" aria-hidden="true" />
      } @else {
      <span class="badge rounded-pill submission-status-badge" [ngClass]="item.badgeClass">{{ item.statusKey | translate
        }}</span>
      @if (item.reason) {
      <span class="submission-status-reason">{{
        "SubmissionStatus.Reason" | translate: { reason: item.reason }
        }}</span>
      }
      }
    </div>
    }
  </div>
</div>